import { getBackEnd } from './backEndUrl';
import { initApiConsumer } from '@urpi/consumer';
import { ApiErrors } from '@integraciones_doc24/wehealthy-api/types/errors';
import { rootApiGroup } from '@integraciones_doc24/wehealthy-api';
import { getUsersEndPoint } from '@integraciones_doc24/wehealthy-api/root/content/getUsers';
import { insertDeactivedAtDateEndPoint } from '@integraciones_doc24/wehealthy-api/root/content/insertDeactivedAtDateEndPoint';
import { changeUserPasswordEndPoint } from '@integraciones_doc24/wehealthy-api/root/content/changeUserPasswordEndPoint';
import { getTotalUsersEndPoint } from '@integraciones_doc24/wehealthy-api/root/content/getTotalUsers';

const backendUrl = getBackEnd();

const apiConsumer = initApiConsumer<ApiErrors.All>(
    `${backendUrl}/api`,
    rootApiGroup,
);

const getUsersApiEndPoint = apiConsumer(getUsersEndPoint);
const insertDeactivedAtDateApiEndPoint = apiConsumer(insertDeactivedAtDateEndPoint);
const changeUserPwd = apiConsumer(changeUserPasswordEndPoint);
const totalUser = apiConsumer(getTotalUsersEndPoint);

export const loadUsers = async (token: string, key: number, apellido?:string, nombre?:string, idNumero?:string, email?:string ) => {
    try {
        const response = await getUsersApiEndPoint(
            { routeParams: { key: key },query:{apellido, nombre, idNumero, email} },
            { headers: { authorization: `Bearer ${token}` } },
        );
        if (!response) {
            throw new Error(`Error`);
        }
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const insertDeactivedAtDate = async (token: string, key: string, fecha: Date | null) => {
    try {
        const response = await insertDeactivedAtDateApiEndPoint(
            {
                routeParams: { key: key },
                body: { deactivatedAt: fecha },
            },
            { headers: { authorization: `Bearer ${token}` } },
        );

        if (!response) {
            throw new Error(`Error`);
        }

        const data = await response;
        return data.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const updatePassword = async (token: string, userId: string, password: string) => {
    try {
        const response = await changeUserPwd(
            {
                body: { userId, password },
            },
            { headers: { authorization: `Bearer ${token}` } },
        );

        if (!response) {
            throw new Error(`Error`);
        }

        const data = await response;
        return data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getTotalUsers = async (token: string) => {
    try{
      const response = await totalUser({} ,{ headers: { authorization: `Bearer ${token}` } });
      return response.data;
    }catch(error){
        console.error(error);
        throw error;
    }
}